<template>
  <div class="account-page">
    <div class="page-header">
      <span class="page-title">账号管理</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">添加账号</span>
      </div>
      <el-form :inline="true" ref="addForm" :model="addForm" :rules="rules" class="mt15">
        <el-form-item prop="username">
          <el-input
            v-model="addForm.username"
            maxlength="11"
            placeholder="账号（只能为手机号）"
            autocomplete="new-password"
            readonly
            @focus="onUsernameFocus"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="addForm.password" type="password" placeholder="密码" autocomplete="new-password" show-password readonly @focus="onPasswordFocus"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="userAdd('addForm')">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">账号列表</span>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        max-height="600"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        stripe
      >
        <el-table-column prop="username" label="帐号" minWidth="140"/>
        <el-table-column label="权限" minWidth="240">
          <template slot-scope="{ row: { role:roles } }">
            <span v-if="!roles || !roles.length" class="empty-text">—</span>
            <el-tag
              v-for="role in roles"
              :key="role"
              size="mini"
              type="info"
              effect="plain"
              class="role-tag"
            >{{ allMenus.filter(z => z.id+'' === role+'')[0] ? allMenus.filter(z => z.id+'' === role+'')[0].name : '' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isAdmin" label="操作" width="160" align="center">
          <template slot-scope="{ row: { id, username, role, hospital_role, tk_role, nurse_role, dis_role, tf_role, cri_role }}">
            <el-link type="primary" icon="el-icon-setting" @click="handleAuth(id, role, hospital_role, tk_role, nurse_role, dis_role, tf_role, cri_role)" class="op-link">授权</el-link>
            <el-link type="danger" icon="el-icon-delete" @click="handleDelete(id, username)" class="op-link">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :current-page="pageNumber"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      title="账户授权"
      :visible.sync="dialogVisible"
      width="640px"
      center
      destroy-on-close
      custom-class="auth-dialog"
    >
      <div class="auth-body">
        <div class="auth-section">
          <div class="auth-section-title">功能授权</div>
          <el-checkbox-group v-model="usrForm.auth" class="auth-check-group">
            <el-checkbox v-for="menu in allMenus" :key="menu.id" :label="menu.id + ''" class="auth-check-item">
              {{ menu.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="usrForm.auth.includes('6')" class="auth-section">
          <div class="auth-section-title">陪护订单授权医院</div>
          <el-checkbox-group v-model="usrForm.hospital" class="auth-check-group">
            <el-checkbox v-for="hospital in hospitalColumns" :key="hospital.id" :label="hospital.id + ''" class="auth-check-item">
              {{ hospital.hospital_name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="usrForm.auth.includes('13')" class="auth-section">
          <div class="auth-section-title">护工管理授权</div>
          <el-checkbox-group v-model="usrForm.nurse_role" class="auth-check-group">
            <el-checkbox v-for="hg_role in nurseMen" :key="hg_role.id" :label="hg_role.id + ''" class="auth-check-item-w">
              {{ hg_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="usrForm.auth.includes('13')" class="auth-section">
          <div class="auth-section-title">特困供养授权</div>
          <el-checkbox-group v-model="usrForm.tk_role" class="auth-check-group">
            <el-checkbox v-for="tk_role in tkMenus" :key="tk_role.id" :label="tk_role.id + ''" class="auth-check-item-w">
              {{ tk_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="usrForm.auth.includes('15')" class="auth-section">
          <div class="auth-section-title">失能人员护理</div>
          <el-checkbox-group v-model="usrForm.dis_role" class="auth-check-group">
            <el-checkbox v-for="dis_role in ordersSnEn" :key="dis_role.id" :label="dis_role.id + ''" class="auth-check-item-w">
              {{ dis_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="usrForm.auth.includes('16')" class="auth-section">
          <div class="auth-section-title">探访关爱授权</div>
          <el-checkbox-group v-model="usrForm.tf_role" class="auth-check-group">
            <el-checkbox v-for="tf_role in ordersTfEn" :key="tf_role.id" :label="tf_role.id + ''" class="auth-check-item-w">
              {{ tf_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="boardingMenuId && usrForm.auth.includes(boardingMenuId)" class="auth-section">
          <div class="auth-section-title">寄宿托养授权</div>
          <el-checkbox-group v-model="usrForm.cri_role" class="auth-check-group">
            <el-checkbox v-for="cri_role in criMenus" :key="cri_role.id" :label="cri_role.id + ''" class="auth-check-item-w">
              {{ cri_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userAdd, userList, userDel, userEdit } from '@/api'
import { isAdmin } from '../utils/util'
import { editUsrRoles, fetchHospitalPList, fetchRolesList } from '../api'

export default {
  data() {
    return {
      addForm: {
        username: '',
        password: '',
        status: false
      },
      formLabelWidth: '143px',
      rules: {
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0-9])|(19[0-9])|(17[0-9])|(16[0-9]))\d{8}$/g,
            message: '请输入正确的手机号'
          }
        ]
      },
      tableData: [],
      usrForm: {
        auth: [],
        hospital: [],
        tk_role: [],
        dis_role: [],
        tf_role: [],
        cri_role: [],
        nurse_role: []
      },
      hospitalColumns: [],
      allMenus: [],
      tkMenus: [],
      ordersSnEn: [],
      ordersTfEn: [],
      nurseMen: [],
      criMenus: [],
      boardingMenuId: '',
      dialogVisible: false,
      tableLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onUsernameFocus(e) {
      e.target.removeAttribute('readonly')
    },
    onPasswordFocus(e) {
      e.target.removeAttribute('readonly')
    },
    async fetchHospital() {
      await fetchHospitalPList().then(res => {
        if (res.status) {
          this.hospitalColumns = [
            ...res.data.list
          ]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      this.getRolesList()
      this.fetchHospital()
      this.getList()
    },
    normalizeRoleIds(val) {
      if (val == null || val === '') return []
      const arr = Array.isArray(val) ? val : String(val).split(/[,，]/)
      return arr.map(i => String(i).trim()).filter(Boolean)
    },
    // *_role 与已能保存的字段一致：有值时前置逗号，如 ",1"
    joinRoleIds(val) {
      const ids = this.normalizeRoleIds(val)
      return ids.length ? `,${ids.join(',')}` : ''
    },
    async handleAuth(id, role, hospital_role, tk_role, nurse_role, dis_role, tf_role, cri_role) {
      this.usrForm.id = id
      this.usrForm.auth = this.normalizeRoleIds(role)
      this.usrForm.hospital = this.normalizeRoleIds(hospital_role)
      this.usrForm.tk_role = this.normalizeRoleIds(tk_role)
      this.usrForm.dis_role = this.normalizeRoleIds(dis_role)
      this.usrForm.tf_role = this.normalizeRoleIds(tf_role)
      this.usrForm.cri_role = this.normalizeRoleIds(cri_role)
      this.usrForm.nurse_role = this.normalizeRoleIds(nurse_role)
      this.dialogVisible = true
    },
    getMenuChildren(res, id) {
      const menu = Object.values(res).find(i => i && Number(i.id) === id)
      if (menu && menu.child) {
        return Object.values(menu.child)
      }
      return []
    },
    async getRolesList() {
      const res = await fetchRolesList()
      this.allMenus = Object.values(res)
      const info = Object.values(res).filter(i => Number(i.id) === 13)[0].child
      this.tkMenus = Object.values(info)
      const info2 = Object.values(res).filter(i => Number(i.id) === 7)[0].child
      this.nurseMen = Object.values(info2)
      const info3 = Object.values(res).filter(i => Number(i.id) === 15)[0].child
      this.ordersSnEn = Object.values(info3)
      const tfChildren = this.getMenuChildren(res, 16)
      this.ordersTfEn = tfChildren.length ? tfChildren : this.ordersSnEn
      // 寄宿托养：优先匹配「残疾人寄宿托养」父级菜单，避免误匹配子项
      const menus = Object.values(res).filter(i => i && i.id != null && i.name)
      const boardingMenu = menus.find(i => String(i.name).indexOf('残疾人寄宿托养') > -1)
        || menus.find(i => String(i.name).indexOf('寄宿托养') > -1 && i.child)
      if (boardingMenu) {
        this.boardingMenuId = String(boardingMenu.id)
        this.criMenus = boardingMenu.child ? Object.values(boardingMenu.child) : []
      }
    },
    async handleSave() {
      const { id, auth, hospital, tk_role, nurse_role, dis_role, tf_role, cri_role } = this.usrForm
      const res = await editUsrRoles({
        id,
        role: this.normalizeRoleIds(auth).join(','),
        hospital_role: this.joinRoleIds(hospital),
        tk_role: this.joinRoleIds(tk_role),
        dis_role: this.joinRoleIds(dis_role),
        tf_role: this.joinRoleIds(tf_role),
        cri_role: this.joinRoleIds(cri_role),
        nurse_role: this.joinRoleIds(nurse_role)
      })
      if (res.status) {
        this.$message.success('保存成功')
        this.getList()
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg || '保存失败')
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageNumber = val
      this.getList()
    },
    userAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            ...this.addForm
          }
          if (this.addForm.hospital && this.addForm.hospital.length > 0) {
            params.hospital_role = this.addForm.hospital.join(',')
          }
          params.status = params.status ? 2 : 1
          userAdd(params).then(res => {
            if (res.status) {
              this.$message.success('添加成功')
              this.resetForm(formName)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    getList() {
      this.tableLoading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      }
      userList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
            this.tableData.forEach(user => {
              user.status = user.status !== 1
              user.is_finance = user.is_finance === 1
              user.is_hospital = user.is_hospital === 1
            })
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    changeStatus(index, id, status, changeKey = 'status') {
      const params = {
        id,
        [changeKey]: changeKey === 'status' ? status ? 2 : 1 : status ? 1 : 0
      }
      userEdit(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
        } else {
          this.tableData[index].status = !status
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete(id, username) {
      this.$confirm(`确定删除账号${username}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userDel({
            id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.account-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.empty-text { color: #c0c4cc; }
.role-tag { margin: 0 6px 6px 0; }
.op-link { margin-right: 12px; }
.block {
  text-align: center;
  margin-top: 20px;
}
.auth-body {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;
}
.auth-section {
  margin-bottom: 18px;
  padding: 12px 14px;
  background: #fafbfc;
  border: 1px solid #f0f2f5;
  border-radius: 6px;
}
.auth-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #26a4b2;
}
.auth-check-group {
  display: flex;
  flex-wrap: wrap;
  padding-left: 8px;
}
.auth-check-item { width: 130px; margin-bottom: 6px; }
.auth-check-item-w { width: 200px; margin-bottom: 6px; }
.dialog-footer { text-align: center; }
</style>
